"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "m4.4149 18.1667 7.17-7.17 1.4142 1.4141-7.17 7.1701z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "m20 7 .94-2.06L23 4l-2.06-.94L20 1l-.94 2.06L17 4l2.06.94zm-2.29 2.12-2.83-2.83c-.2-.19-.45-.29-.71-.29s-.51.1-.71.29L2.29 17.46c-.39.39-.39 1.02 0 1.41l2.83 2.83c.2.2.45.3.71.3s.51-.1.71-.29l11.17-11.17c.39-.39.39-1.03 0-1.42M5.83 19.59l-1.41-1.41L11.59 11 13 12.41zM14.41 11 13 9.59l1.17-1.17 1.41 1.41z"
}, "1")], 'AutoFixNormalTwoTone');